module.exports = __webpack_public_path__ + "img/slide-relateditems_inactive.d3a65f26.svg";